import { render } from "./CooperateShop.vue?vue&type=template&id=576a02d2&scoped=true"
import script from "./CooperateShop.vue?vue&type=script&lang=js"
export * from "./CooperateShop.vue?vue&type=script&lang=js"

import "./CooperateShop.vue?vue&type=style&index=0&id=576a02d2&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-576a02d2"]])

export default __exports__